import { useController, type UseFormReturn } from 'react-hook-form';
import type { ExtractStringKeys } from '../../../types/extractKeysOfType';
import { Controlled_RichText } from '../../inputs/controlled/Controlled_RichText';

export const Form_RichText = <T extends object>({
    name,
    form,
    readonly,
    toolBarOnFocus,
    maxContentHeight,
}: {
    name: ExtractStringKeys<T, false>;
    form: UseFormReturn<T>;
    readonly: boolean;
    toolBarOnFocus?: boolean;
    maxContentHeight?: number;
}) => {
    const {
        field: { value, onChange: valueOnChange },
    } = useController({
        control: form.control,
        name,
    });

    return (
        <Controlled_RichText
            value={value}
            onChange={valueOnChange}
            readonly={readonly}
            toolBarOnFocus={toolBarOnFocus}
            maxContentHeight={maxContentHeight}
        />
    );
};
